import axios from 'axios'

const api = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
})

//Global catch error handler
api.interceptors.response.use((response) => response, async (error) => {
    const token = window.sessionStorage.getItem('auth_token_default')

    if(error.response && ![401, 403].includes(error.response.status)) {
        axios.post(`${process.env.VUE_APP_API_URL}/api/v1/elastic_search/log`, {
            // Only an extract: the whole error carries the request headers (the user's token) and body (passwords among others)
            error: {
                name: error.name,
                message: error.message,
                code: error.code,
                status: error.response?.status,
                method: error.config?.method,
                url: error.config?.url
            },
            message: error.response?.data ?? "empty"
        }, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
    }

    //Catch expired token for /auth/me request
    if ((error.response.data.status === 498 || error.response.data.status === 403) && error.response.request.responseURL.includes('auth/me')) {
        document.dispatchEvent(new Event('tokenExpired'))
    }

    //Throw error for other request errors
    throw error
});

export default api